export default __webpack_public_path__ + "static/media/expand.a6ccdb0e.svg";